declare global {
  interface String {
    capitalizeFirstLetter(): string;
  }
}

String.prototype.capitalizeFirstLetter = function () {
  if (!this) {
    return;
  }
  return this.charAt(0).toUpperCase() + this.slice(1).toLowerCase();
};

export {};
